import { ErrorResponse } from "../../../utils/types/generals"

export type FinishActivity = {
    code: CodeFinishActivity,
    message: string
} & ErrorResponse

export enum CodeFinishActivity {
    SUCCESS = '01'
}